// src/components/DeleteAreaClientModal.js
import React, { useState } from "react";
import "./DeleteAreaClientModal.css";
import { API_URL } from "../config";

function DeleteAreaClientModal({ onClose, onDeleteSuccess }) {
  const [step, setStep] = useState(1);
  const [type, setType] = useState(null);
  const [list, setList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchList = async (selectedType) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/${selectedType}`, {
        method: "GET",
        credentials: "include",
      });
      if (!response.ok) throw new Error(`Błąd pobierania listy ${selectedType}`);
      const data = await response.json();
      setList(data);
      setType(selectedType);
      setStep(2);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleDelete = () => {
    if (selectedItems.length === 0) {
      setError("Nie zaznaczono żadnej nazwy");
      return;
    }
    setError("");
    setStep(3);
  };

  const confirmDelete = async () => {
    setLoading(true);
    setError(""); // Wyczyść stary błąd przed nową próbą

    try {
      const response = await fetch(`${API_URL}/${type}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ ids: selectedItems }),
      });

      // Jeśli odpowiedź NIE jest OK (np. 409 Conflict)
      if (!response.ok) {
        // Spróbuj odczytać błąd z ciała odpowiedzi JSON
        const errorData = await response.json().catch(() => {
          // Jeśli ciało odpowiedzi nie jest w formacie JSON
          throw new Error(`Błąd serwera: ${response.status} ${response.statusText}`);
        });
        // Rzuć błąd z komunikatem od serwera
        throw new Error(errorData.error || `Błąd usuwania ${type}`);
      }
      
      // Jeśli wszystko poszło dobrze
      onDeleteSuccess();

    } catch (err) {
      // Wyświetl błąd w modalu i wróć do kroku 2
      setError(err.message);
      setStep(2);
    } finally {
      setLoading(false);
    }
  };

  if (step === 1) {
    return (
      <div className="modal-overlay">
        {/* Zmieniona klasa */}
        <div className="delete-modal-content">
          <h3>Wybierz, co chcesz usunąć</h3>
          <ul>
            <li onClick={() => fetchList("areas")}>Obszary</li>
            <li onClick={() => fetchList("clients")}>Klienci</li>
          </ul>
          <button className="btn-submit" style={{ marginTop: "1rem" }} onClick={onClose}>
            Anuluj
          </button>
        </div>
      </div>
    );
  }

  if (step === 2) {
    return (
      <div className="modal-overlay">
        {/* Zmieniona klasa */}
        <div className="delete-modal-content">
          <h3>Wybierz {type === "areas" ? "obszary" : "klientów"} do usunięcia</h3>
          {loading ? (
            <p>Ładowanie...</p>
          ) : list.length === 0 ? (
            <p>Brak {type === "areas" ? "obszarów" : "klientów"} do usunięcia</p>
          ) : (
            <div className="list-container">
              <ul>
                {list.map((item) => (
                  <li key={item.id}>
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(item.id)}
                      onChange={() => handleSelectItem(item.id)}
                    />
                    <span className="item-name">{item.name}</span>
                    <span className="item-description">
                      {type === "clients" ? item.contact_info : item.description}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {error && <p className="error-message">{error}</p>}
          <div className="modal-buttons">
            <button className="btn-submit" onClick={handleDelete} disabled={selectedItems.length === 0}>
              Usuń ({selectedItems.length})
            </button>
            <button className="btn-submit" onClick={onClose}>
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (step === 3) {
    const selectedNames = list
      .filter((item) => selectedItems.includes(item.id))
      .map((item) => item.name)
      .join(", ");

    return (
      <div className="modal-overlay">
        {/* Zmieniona klasa */}
        <div className="delete-modal-content">
          <h3>Potwierdź usunięcie</h3>
          <p className="confirmation-text">
            Czy jesteś pewny, że chcesz usunąć z listy {type === "areas" ? "obszarów" : "klientów"} te nazwy: {selectedNames}?
          </p>
          {loading ? (
            <p>Usuwanie...</p>
          ) : (
            <div className="modal-buttons">
              <button className="btn-submit" onClick={confirmDelete}>
                Potwierdź i Usuń
              </button>
              <button className="btn-submit" onClick={() => setStep(2)}>
                Anuluj
              </button>
            </div>
          )}
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
    );
  }

  return null;
}

export default DeleteAreaClientModal;